<template>
    <div>
        <div class="form-horizontal">

            <form-input :form="form" property="title"></form-input>
            <form-input :form="form" property="name"></form-input>
            <form-input :form="form" property="slug"></form-input>
            <form-input :form="form" property="meta_keyword"></form-input>
            <form-input :form="form" property="meta_keywords"></form-input>
            <form-input :form="form" property="meta_description">
                <textarea v-model="form.meta_description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>
            <form-input :form="form" property="description">
                <textarea v-model="form.description" class="form-control" cols="10" rows="5"></textarea>
            </form-input>

            <form-input :form="form" property="image" label="Photo">
                <photo-upload @input="files.image = $event" :value="form.image.url" @clear="files.image = null; form.image = {url: ''}"></photo-upload>
            </form-input>

            <form-input-trans :form="form" property="image.alt"></form-input-trans>

            <activity-log v-if="exists" :api="`/api/blogs/tags/${form.id}/activity`" ref="activityLog"></activity-log>


        </div>
    </div>
</template>


<script>

import Model from 'lib/Model';
import Form from 'lib/Form';
import UploadFiles from 'lib/UploadFiles';

export default {
    mixins: [Model, UploadFiles],
    data() {
        return {
            method: '/api/blogs/tags',
            form: new Form(() => {
                return {
                    name: '',
                    title: '',
                    slug: '',
                    meta_keyword: '',
                    meta_keywords: '',
                    meta_description: '',
                    description: '',
                    image: {
                        alt: {}
                    },
                };
            })
        };
    },
    mounted() {
        this.$on('input', () => {
            if (this.$refs.activityLog) {
                this.$refs.activityLog.load();
            }
        });
    },
};
</script>



// WEBPACK FOOTER //
// resources/js/forms/blogs/Tag.vue